/**
 * Browser shim for Node `node:path` imports that leak into the bundle from
 * server-only `@smart-shikka/core` modules. This shim exists only so the SPA
 * build can tree-shake unused server code paths; any function actually called
 * at runtime is a developer error and fails loudly.
 */

function notAvailable(name: string): () => never {
  return () => {
    throw new Error(`node:path.${name} is not available in the browser bundle`);
  };
}

export const basename = notAvailable("basename");
export const dirname = notAvailable("dirname");
export const extname = notAvailable("extname");
export const format = notAvailable("format");
export const isAbsolute = notAvailable("isAbsolute");
export const join = notAvailable("join");
export const normalize = notAvailable("normalize");
export const parse = notAvailable("parse");
export const relative = notAvailable("relative");
export const resolve = notAvailable("resolve");
export const toNamespacedPath = notAvailable("toNamespacedPath");
export const sep = "/";
export const delimiter = ":";
export const posix = {} as unknown as typeof import("node:path").posix;
export const win32 = {} as unknown as typeof import("node:path").win32;

const path = {
  basename, dirname, extname, format, isAbsolute, join, normalize, parse, relative,
  resolve, toNamespacedPath, sep, delimiter, posix, win32,
};
export default path;
